module.exports = __webpack_public_path__ + "img/share_bg.30c6ea4e.png";